module.exports = __webpack_public_path__ + "static/bridge-logo-377f5c2ad85de7747f8e3a93332cfbc1.png";